import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)

export default new Router({
  mode: 'history',
  base: '/h6/',
  routes: [
    {
      path: "/login",
      name: "Login",
      meta: {
        title: "登录"
      },
      component: () => import("@/views/login/index.vue")
    },{
      path: "/index",
      name: "Index",
      meta: {
        title: "首页"
      },
      component: () => import("@/views/index.vue")
    },{
      path: "/detail",
      name: "detail",
      meta: {
        title: "卡详情"
      },
      component: () => import("@/views/page/detail.vue")
    },{
      path: "/create",
      name: "create",
      meta: {
        title: "卡下单"
      },
      component: () => import("@/views/page/create.vue")
    },{
      path: "/art",
      name: "art",
      meta: {
        title: "内容详情"
      },
      component: () => import("@/views/art.vue")
    },{
      path: "/glist",
      name: "glist",
      meta: {
        title: "商品列表"
      },
      component: () => import("@/views/goods/list.vue")
    },{
      path: "/gdetail",
      name: "gdetail",
      meta: {
        title: "商品详情"
      },
      component: () => import("@/views/goods/detail.vue")
    },{
      path: "/agree",
      name: "agree",
      meta: {
        title: "公告"
      },
      component: () => import("@/views/agree.vue")
    },{
      path: "/daliang",
      name: "daliang",
      meta: {
        title: "大流量专区"
      },
      component: () => import("@/views/page/daliang.vue")
    },{
      path: "/detail_two",
      name: "/detail_two",
      meta: {
        title: "卡详情"
      },
      component: () => import("@/views/page/detail_two.vue")
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js